import idID from './language/id.json'
import enUS from './language/en.json'

export default {
  'id-ID': idID,
  'en-US': enUS,
};
